/**
 * A payment reference is numeric-only on the backend; any non-digit value 500s the
 * `gozem_money/payments/history` endpoint. This is the single source of truth for that
 * rule, shared by the search input (`onSearchChanged`) and the URL-restore path
 * (`FilterUrlService.decodeParamsToFilters`) so the two can never disagree.
 *
 * @returns `true` only for a non-empty string of digits.
 */
export function isNumericReference(term: string): boolean {
  return term.length > 0 && !/\D/.test(term);
}
